import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, roles, allowOpname = false, allowPajak = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500 text-sm">
        Memuat sesi…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Opname-only users hanya boleh route dengan allowOpname / allowPajak
  if (user.opname_only) {
    if ((allowOpname && user.opname_enabled) || (allowPajak && user.pajak_enabled)) return children;
    return <Navigate to={user.home_route || '/stock-opname'} replace />;
  }
  // Sales hanya boleh Sales Price Catalog + Stock Opname (bila opname_enabled)
  if (user.role === 'sales') {
    const allowed = (roles && roles.includes('sales')) || (allowOpname && user.opname_enabled);
    if (!allowed) return <Navigate to="/sales/catalog" replace />;
    return children;
  }
  const passRoles = !roles || roles.includes(user.role);
  const passOpname = allowOpname && user.opname_enabled;
  const passPajak = allowPajak && (user.role === 'admin' || user.pajak_enabled);
  if (roles && !passRoles && !passOpname && !passPajak) {
    const home = user.role === 'admin' ? '/admin'
      : user.role === 'sales' ? '/sales/catalog'
      : user.opname_enabled ? '/stock-opname' : '/kasir';
    return <Navigate to={home} replace />;
  }
  return children;
}
